import {Navigate, useParams} from 'react-router-dom'
import Loader from '../../../components/Loader'
import {useClientPermission} from '../../../hooks/permission.hooks'
import Error403 from '../../../routes/Error403'
import {getDefaultSettingsSection} from './sections'

/**
 * Bare `…/settings` lands on the first section the user may open; a user with
 * none gets the 403 page.
 */
export default function SettingsIndexRedirect() {
  const {clientId} = useParams()
  const {can, isLoading} = useClientPermission(clientId)

  if (isLoading) return <Loader variant='overlay' />

  const section = getDefaultSettingsSection(can)
  if (!section) return <Error403 />

  return <Navigate to={section} replace />
}
